
<v-row>
	<v-col :cols="6">
		<v-row v-if="!showDateSelection" class="mt-2 pl-2 pr-2" align="center" justify="center">
			<calendar-date-icon
				v-for="day in bookingDates"
				:key="getDayDate(day)"
				color="green"
				:card_color="''"
				:card_text_color="''"
				:date="getDayDate(day)"
				:start_time="getDayStart(day)"
				:end_time="getDayEnd(day)"
				small
				class="ml-1 mr-1 mt-2 mb-0 justify-center text-center"
			>
			</calendar-date-icon>
		</v-row>
		<v-row v-if="showDateSelection">
			<v-col class="date-selection-wrapper">
				<v-checkbox v-model="AllDates" label="Select All Dates" @click="SelectAllDates()"></v-checkbox>
			</v-col>
		</v-row>
		<div v-if="showDateSelection" :key="keyboi" class="date-selection-wrapper">
			<v-row class="pt-2" no-gutters align="center" justify="center">
				<v-card
					v-for="date in dateSelection"
					:key="date.date"
					outlined
					elevation="1"
					class="ml-1 mr-1 mt-2 mb-2 pl-1 pr-1"
					style="border-radius: 8px; !important"
					@click="onClickDateIcon(date)"
				>
					<v-row no-gutters>
						<v-col cols="12">
							<calendar-date-icon
								:color="getDayColor(date)"
								:date="date.date"
								:start_time="getLocumDayTime(date.date, 'start_time')"
								:end_time="getLocumDayTime(date.date, 'end_time')"
								small
								class="ml-1 mr-1 mt-2 mb-0 justify-center text-center"
								@click="onClickDateIcon(date)"
							>
							</calendar-date-icon>
						</v-col>
					</v-row>
					<v-row v-if="isDayAvailable(date)" no-gutters align="center" justify="center" class="pl-0 pt-1 pb-0 mb-1">
						<v-icon v-if="!(date.date in selectedDates && selectedDates[date.date])" color="primary" class="pa-0 ma-0" @click="onClickDateIcon(date)"
							>radio_button_unchecked</v-icon
						>
						<v-icon v-else color="#63C367" class="pa-0 ma-0" @click="onClickDateIcon(date)">radio_button_checked</v-icon>
					</v-row>
					<v-row v-else no-gutters align="center" justify="center" class="pl-0 pt-1 pb-0 mb-1"><v-icon color="grey">not_interested</v-icon></v-row>
				</v-card>
			</v-row>
		</div>
	</v-col>
	<v-col :cols="6" align="left" justify="left">
		<div v-if="booking.profession" class="mt-2">
			<small>
				<strong>Profession:</strong>
				{{ booking.profession }}
			</small>
		</div>
		<!-- TODO - May be re-added later -->
		<!-- <div>
			<small>
				<strong>Rates:</strong>
				{{ formattedRates }}
			</small>
		</div>
		<div>
			<small>
				<strong>Experience:</strong>
				{{ formattedExperience }}
			</small>
		</div> -->
		<div v-if="booking.start_time && showTimes">
			<small>
				<strong>Start Time:</strong>
				{{ booking.start_time }}
			</small>
		</div>
		<div v-if="booking.end_time && showTimes">
			<small>
				<strong>End Time:</strong>
				{{ booking.end_time }}
			</small>
		</div>

		<div v-if="formattedSkills">
			<small>
				<strong>Requirements:</strong>
				{{ formattedSkills }}
			</small>
		</div>

		<div v-if="formattedRates && !isLocumViewingPractice">
			<small>
				<strong>Budget:</strong>
				{{ formattedRates }}
			</small>
		</div>

		<div v-if="booking.lunch">
			<small>
				<strong>Lunch:</strong>
				{{ lunchDetails }}
			</small>
		</div>

		<div v-if="booking.notes">
			<div>
				<small>
					<strong>Notes:</strong>
				</small>
			</div>

			<div>
				<small>
					{{ booking.notes }}
				</small>
			</div>
		</div>
	</v-col>
</v-row>
